import { PaginatedTable } from '@app/components';
import { TableProps } from '@app/components/table';
import useResponsive from '@app/hooks/use-responsive';
import { IModule } from '../../types';
import { DialogModuleRow } from './module-row';

const TABLE_HEAD = [
  { id: 'Module', label: 'Module', align: 'left' },
  { id: 'Read', label: 'Read', align: 'left' },
  { id: 'Write', label: 'Write', align: 'left' },
];

interface Props {
  tableProps: TableProps;
  rows?: IModule[];
  loading: boolean;
  disabledModules: any;
}

const DialogModuleList = ({ tableProps, rows, loading, disabledModules }: Props) => {
  const isMobile = useResponsive('down', 'sm');

  return (
    <PaginatedTable<IModule>
      head={TABLE_HEAD}
      tableProps={tableProps}
      data={rows}
      loading={loading}
      paginationShown={false}
      sx={{ minWidth: isMobile ? 280 : 450 }}
    >
      {(row) => <DialogModuleRow row={row} disabledModules={disabledModules} />}
    </PaginatedTable>
  );
};

export default DialogModuleList;
